import {
  SAVE_SERVICE,
  SAVE_SERVICE_SUCCESS,
  SAVE_SERVICE_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  service: {},
  error: []
};

export const newServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_SERVICE:
      return { ...state, isSaving: true };
    case SAVE_SERVICE_SUCCESS:
      return { ...state, isSaving: false, service: action.payload };
    case SAVE_SERVICE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newService.isSaving;
export const getService = state => state.newService.service;
export const getError = state => state.newService.error;



// WEBPACK FOOTER //
// ./src/modules/ServiceForm/reducer.js